import React from 'react';

const GalleryLayout2 = ({title,products}) => {  
  return (
<section data-bs-version="5.1" className="pricing5 shopm5 cid-uATHtvPEJO" id="apricing5-4">
<div className="position-relative">
        <div className="mbr-section-head">
            <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2"><strong>{title}</strong></h4>
            
        </div>        
    </div>
    
    <div className="container-fluid">
        
        <div className="row align-items-stretch items-row justify-content-center">
{products.map((product) => (
   <div className="item features-image col-6 col-md-6 col-lg-3" key={product.id}>
                <div className="item-wrapper">
                    <div className="item-img">
                        <img src={product.imageUrl} alt={product.name} />
                    </div>
                    <div className="item-content align-center">
                        <h5 className="item-title mbr-fonts-style mb-0 display-7">{product.name}</h5>
                        <p className="item-subtitle mbr-fonts-style mb-0 display-7"><strong>{product.title}</strong></p>
                        <p className="mbr-text mbr-fonts-style mb-0 display-7">
                            <strong>Rs. {product.price}</strong>
                        </p>
                    </div>
                    <br /><br /><br /><br /><br />
                    <div className="mbr-section-btn align-center align-center"><a href="" className="btn item-btn btn-danger display-7" target="_blank">Buy</a></div>
                </div>
            </div>
))}
        </div>
    </div>
</section>    
  );
};

export default GalleryLayout2;
